<ng-template #headerContent>
  <dot-matrix-loader size="20px" [paused]="!active()" />
  <span class="label" aria-live="polite">{{ label() }}</span>
  @if (elapsedSeconds() !== null) {
    <span class="timer" aria-hidden="true">{{ elapsedSeconds() }}s</span>
  }
</ng-template>

@if (hasBody()) {
  <button
    type="button"
    class="header"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="bodyId"
    (click)="toggle()"
  >
    <ng-container [ngTemplateOutlet]="headerContent" />
    <ng-icon class="chevron" [class.up]="expanded()" name="tablerChevronDown" size="16px" />
  </button>
} @else {
  <div class="header">
    <ng-container [ngTemplateOutlet]="headerContent" />
  </div>
}

@if (hasBody() && expanded()) {
  <div class="body" [id]="bodyId">
    @for (thought of thoughts(); track $index) {
      <p class="thought">{{ thought }}</p>
    }
    @if (tasks().length) {
      <reasoning-task-list [tasks]="tasks()" [active]="active()" />
    }
  </div>
}
